export default __webpack_public_path__ + "static/media/placeholder1.1add8082.png";